module.exports = __webpack_public_path__ + "img/NEF_music_on.63344964.svg";